export default __webpack_public_path__ + "static/media/icon_edit.61539464.svg";